(() => {
  if (customElements.get('cgl-photo-customizer')) return;

  class CglPhotoCustomizer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const find = (selector) => this.querySelector(selector);

      this.product = this.readJson('[data-cgl-product-json]') || { options:[], variants:[] };
      this.assets = this.readJson('[data-cgl-assets-json]') || { pendants:{}, pendantsSilver:{}, chains:{}, chainsSilver:{} };
      this.form = find('.cgl-pc__form');
      this.formHome = find('[data-cgl-form-home]');
      this.dock = find('[data-cgl-dock]');
      this.productIntro = find('[data-cgl-product-intro]');
      this.variantInput = find('[data-cgl-variant-id]');
      this.originalFileInput = find('[data-cgl-original-file]');
      this.photoLayer = find('[data-cgl-photo-layer]');
      this.photoWindow = find('[data-cgl-photo-window]');
      this.photoComposite = find('[data-cgl-photo-composite]');
      this.pendantComposite = find('[data-cgl-pendant-composite]');
      this.pendantLayer = find('[data-cgl-pendant-layer]');
      this.chainLayer = find('[data-cgl-chain-layer]');
      this.stage = find('[data-cgl-stage]');
      this.productPlaceholder = find('[data-cgl-product-placeholder]');
      this.previewCard = find('[data-cgl-preview-edit]');
      this.resetButton = find('[data-cgl-reset-photo]');
      this.interactionCue = find('[data-cgl-interaction-cue]');
      this.photoAssurance = find('[data-cgl-photo-assurance]');
      this.stageEmpty = find('[data-cgl-stage-empty]');
      this.photoPrimaryButton = find('[data-cgl-photo-primary]');
      this.photoPrimaryHome = find('[data-cgl-photo-primary-home]');
      this.photoEditorAction = find('[data-cgl-photo-editor-action]');
      this.photoSection = find('[data-cgl-section="photo"]');
      this.photoPrimaryLabel = find('[data-cgl-photo-primary-label]');
      this.photoConfirmedRow = find('[data-cgl-photo-confirmed]');
      this.photoEditsWrap = find('[data-cgl-photo-edits-wrap]');
      this.photoEditInputs = [...this.querySelectorAll('[data-cgl-photo-edit]')];
      this.photoEditOther = find('[data-cgl-photo-edit-other]');
      this.infoDialog = find('[data-cgl-info-dialog]');
      this.infoTitle = find('[data-cgl-info-title]');
      this.infoPanels = [...this.querySelectorAll('[data-cgl-info-panel]')];
      this.infoTriggers = [...this.querySelectorAll('[data-cgl-info-trigger]')];
      this.infoCloseButtons = [...this.querySelectorAll('[data-cgl-info-close]')];
      this.infoReturnFocus = null;
      this.photoError = find('[data-cgl-photo-error]');
      this.pendantError = find('[data-cgl-pendant-error]');
      this.formError = find('[data-cgl-form-error]');
      this.recap = find('[data-cgl-recap]');
      this.recapImage = find('[data-cgl-recap-image]');
      this.naturalBuybar = find('[data-cgl-buybar-natural]');
      this.stickyBuybar = find('[data-cgl-buybar-sticky]');
      this.actionButtons = [...this.querySelectorAll('[data-cgl-action]')];
      this.buybars = [...this.querySelectorAll('[data-cgl-buybar]')];
      this.progressTracks = [...this.querySelectorAll('[data-cgl-progress-track]')];
      this.progressFills = [...this.querySelectorAll('[data-cgl-progress-fill]')];
      this.thumbnailImages = [...this.querySelectorAll('[data-cgl-thumbnail]')];
      this.postAtcOffer = find('[data-cgl-post-atc-offer]');
      this.offerDialog = find('[data-cgl-offer-dialog]');
      this.offerMain = find('.cgl-pc__offer-main');
      this.offerTitle = find('[data-cgl-offer-title]');
      this.offerBuilder = find('[data-cgl-offer-builder]');
      this.offerBuilderTitle = find('#CglOfferBuilderTitle-' + this.dataset.sectionId);
      this.offerBuilderHost = find('[data-cgl-offer-builder-host]');
      this.offerBuilderBack = find('[data-cgl-offer-builder-back]');
      this.offerBuildingLabel = find('[data-cgl-offer-building-label]');
      this.offerEditButton = find('[data-cgl-offer-edit]');
      this.offerDuplicateButton = find('[data-cgl-offer-duplicate]');
      this.offerBenefits = find('[data-cgl-offer-benefits]');
      this.offerShop = find('[data-cgl-offer-shop]');
      this.offerShopTitle = find('[data-cgl-offer-shop-title]');
      this.offerItemImage = find('[data-cgl-offer-item-image]');
      this.offerSecondSlot = find('[data-cgl-offer-second-slot]');
      this.offerFreeSlot = find('[data-cgl-offer-free-slot]');
      this.embeddedBracelet = null;
      this.braceletMarkup = '';
      this.embeddedSpinning = null;
      this.spinningMarkup = '';
      this.offerBuilderType = '';
      this.offerPickerTarget = '';
      this.offerEligibleIds = [this.dataset.cglProductId,this.dataset.cglBraceletId,this.dataset.cglSpinningId].filter(Boolean).map(Number);
      this.lastAddedKey = '';
      this.editingCartKey = '';

      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.fixedPendant = this.dataset.fixedPendant === 'true';
      this.build = {
        selected:{
          Pendant:this.dataset.defaultPendant || 'Circle',
          Chain:'Rope',
          Material:'Signature'
        },
        color:this.dataset.defaultColor || 'Gold',
        length:'18"',
        pendantChosen:this.fixedPendant,
        colorChosen:false,
        materialChosen:true,
        photoConfirmed:false,
        photoState:{ url:'', renderable:false, aspect:1, zoom:1, offsetX:0, offsetY:0, adjusted:false },
        originalFile:null,
        productionFile:null,
        productionPromise:null,
        previewFile:null,
        previewUrl:'',
        previewCacheKey:''
      };
      this.loading = false;
      this.photoEditing = false;
      this.pointers = new Map();
      this.failedThumbnailSources = new Set();
      this.imageCache = new Map();
      this.previewPromise = null;
      this.previewPromiseKey = '';
      this.naturalCtaSeen = false;
      this.deliveryEstimate = this.buildDeliveryEstimate(17,21);
      this.analyticsVersion = '1.1.0';
      this.analyticsDebug = new URLSearchParams(window.location.search).get('cgl_debug') === '1';
      this.persistenceVersion = 1;
      this.persistenceDays = 7;
      this.analyticsOnce = new Set();
      this.photoAdjustmentTracked = false;
      this.cglSessionId = this.getOrCreateSessionId();
      this.cglCustomizationId = this.getOrCreateCustomizationId();
      this.acquisition = this.getOrCaptureAcquisition();

      this.pendantGeometry = {
        Circle:{ width:.52, top:.29, aspect:1, window:[.17,.29,.66,.68] },
        'Circle Plus':{ width:.74, top:.26, aspect:1, window:[.17,.29,.66,.68] },
        'Circle XL':{ width:.80, top:.23, aspect:1, window:[.17,.29,.66,.68] },
        Heart:{ width:.56, top:.28, aspect:1, window:[.11,.24,.78,.74] },
        Wings:{ width:.78, top:.30, aspect:1.31, window:[.28,.31,.44,.60] },
        Rectangle:{ width:.78, top:.27, aspect:1, window:[.24,.25,.52,.74] }
      };

      this.restoreProgress();
      this.setupThumbnailFallbacks();
      this.setText('[data-cgl-delivery-date]',this.deliveryEstimate);
      this.bindEvents();
      this.updateAll();
      this.initDockBehavior();
      this.initStickyBuybar();
      this.initAnalyticsView();
      this.scheduleArtworkPreload();
    }

    disconnectedCallback() {
      if (this.build?.photoState.url) URL.revokeObjectURL(this.build.photoState.url);
      if (this.build?.previewUrl) URL.revokeObjectURL(this.build.previewUrl);
      window.clearTimeout(this.previewTimer);
      window.clearTimeout(this.cueTimer);
      window.clearTimeout(this.photoSnapTimer);
      window.clearTimeout(this.productionTimer);
      if (this.artworkIdleId && 'cancelIdleCallback' in window) window.cancelIdleCallback(this.artworkIdleId);
      else window.clearTimeout(this.artworkIdleId);
      window.removeEventListener('scroll',this.dockScrollFallback);
      window.removeEventListener('resize',this.dockScrollFallback);
      window.cancelAnimationFrame(this.dockFrame);
      this.buybarObserver?.disconnect();
      this.analyticsViewObserver?.disconnect();
      window.removeEventListener('scroll',this.buybarFallback);
      window.cancelAnimationFrame(this.buybarFrame);
      document.removeEventListener('keydown',this.offerKeydown);
      if (this.infoDialog?.open) this.infoDialog.close();
      document.body.classList.remove('cgl-pc-info-open');
      document.body.classList.remove('cgl-pc-offer-open','cgl-pc-offer-builder-open','cgl-pc-photo-editing');
      if (this.offerPreviewUrl) URL.revokeObjectURL(this.offerPreviewUrl);
      this.imageCache?.clear();
    }

    readJson(selector) {
      try { return JSON.parse(this.querySelector(selector)?.textContent || 'null'); }
      catch (error) { console.error('CustomGLD customizer JSON error',error); return null; }
    }

    buildDeliveryEstimate(minDays,maxDays) {
      const addDays = (days) => {
        const date = new Date();
        date.setDate(date.getDate() + days);
        return date;
      };
      const earliest = addDays(minDays);
      const latest = addDays(maxDays);
      const month = (date) => date.toLocaleString('en-US',{ month:'short' });
      return earliest.getMonth() === latest.getMonth()
        ? `${month(earliest)} ${earliest.getDate()}–${latest.getDate()}`
        : `${month(earliest)} ${earliest.getDate()} – ${month(latest)} ${latest.getDate()}`;
    }

    bindEvents() {
      this.querySelectorAll('[data-cgl-option]').forEach((input) => {
        input.addEventListener('change',() => this.selectOption(input.dataset.cglOption,input.value));
      });
      this.querySelectorAll('[data-cgl-color]').forEach((input) => {
        input.addEventListener('change',() => {
          this.build.color = input.value;
          this.build.colorChosen = true;
          this.invalidatePreview();
          this.updateAll();
          this.schedulePreview();
          this.persistProgress('pendant');
          this.emitEvent('color_selected');
        });
      });
      this.querySelectorAll('[data-cgl-length]').forEach((input) => {
        input.addEventListener('change',() => {
          this.build.length = input.value;
          this.updateAll();
          this.persistProgress('chain');
          this.emitEvent('length_selected');
        });
      });
      this.photoEditsWrap?.addEventListener('toggle',() => {
        if (this.photoEditsWrap.open) this.emitEvent('photo_touchups_opened');
      });
      this.photoEditInputs.forEach((input) => input.addEventListener('change',() => {
        this.updatePhotoEditDetails();
        this.hideError(this.photoError);
        this.emitEvent('photo_touchup_changed',{ touchup:this.safeAnalyticsValue(input.value), selected:input.checked });
      }));
      this.photoEditOther?.addEventListener('input',() => this.hideError(this.photoError));
      this.infoTriggers.forEach((button) => button.addEventListener('click',() => this.openInfoDialog(button.dataset.cglInfoTrigger,button)));
      this.infoCloseButtons.forEach((button) => button.addEventListener('click',() => this.closeInfoDialog()));
      this.infoDialog?.addEventListener('cancel',(event) => {
        event.preventDefault();
        this.closeInfoDialog();
      });
      this.infoDialog?.addEventListener('click',(event) => {
        if (event.target === this.infoDialog) this.closeInfoDialog();
      });
      this.photoPrimaryButton?.addEventListener('click',() => {
        if (this.build.photoState.renderable && !this.build.photoConfirmed) this.confirmPhoto();
        else this.triggerPhotoPicker();
      });
      this.querySelectorAll('[data-cgl-photo-trigger]').forEach((button) => button.addEventListener('click',() => this.triggerPhotoPicker()));
      this.originalFileInput?.addEventListener('change',(event) => this.handlePhotoFile(event.target.files?.[0]));
      this.resetButton?.addEventListener('click',(event) => {
        event.stopPropagation();
        this.resetPhotoTransform();
      });
      this.previewCard?.addEventListener('click',() => this.editPhotoFromPreview());
      this.previewCard?.addEventListener('keydown',(event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.editPhotoFromPreview();
      });
      this.stage?.addEventListener('pointerdown',(event) => this.onPointerDown(event));
      this.stage?.addEventListener('pointermove',(event) => this.onPointerMove(event));
      this.stage?.addEventListener('pointerup',(event) => this.onPointerUp(event));
      this.stage?.addEventListener('pointercancel',(event) => this.onPointerUp(event));
      this.actionButtons.forEach((button) => button.addEventListener('click',() => this.handleAddToCart()));
      this.form?.addEventListener('submit',(event) => { event.preventDefault(); this.handleAddToCart(); });
      this.querySelectorAll('[data-cgl-offer-cart-link]').forEach((link) => link.addEventListener('click',() => {
        this.emitEvent('post_atc_continue_cart',{ eligible_cart_quantity:this.offerEligibleQuantity || 1 });
      }));
      this.querySelectorAll('[data-cgl-offer-product-link]').forEach((link) => link.addEventListener('click',(event) => {
        event.preventDefault();
        this.openOfferBuilder(link.dataset.cglOfferProductType || 'photo_pendant');
      }));
      this.offerSecondSlot?.addEventListener('click',() => this.openOfferPicker('second'));
      this.offerFreeSlot?.addEventListener('click',() => this.openOfferPicker('free'));
      this.offerBuilderBack?.addEventListener('click',() => this.showOfferDecision(true));
      this.offerBuilderHost?.addEventListener('cgl:embedded-item-added',(event) => this.handleEmbeddedItemAdded(event));
      this.offerEditButton?.addEventListener('click',() => this.openOfferBuilder('photo_pendant',{ preserve:true, editing:true }));
      this.offerDuplicateButton?.addEventListener('click',() => this.duplicateOfferPiece());
      this.offerKeydown = (event) => this.handleOfferKeydown(event);
    }

    selectOption(name,value) {
      if (name === 'Pendant' && this.fixedPendant && value !== this.dataset.defaultPendant) return;
      this.build.selected[name] = value;
      if (name === 'Pendant') {
        this.build.pendantChosen = true;
        this.hideError(this.pendantError);
      }
      if (name === 'Material') this.build.materialChosen = true;
      const changesArtwork = name === 'Pendant' || name === 'Chain';
      if (changesArtwork) this.invalidatePreview();
      this.updateAll();
      if (changesArtwork) this.schedulePreview();
      this.persistProgress(name === 'Pendant' ? 'pendant' : name === 'Chain' ? 'chain' : 'material');
      this.emitEvent(`${name.toLowerCase()}_selected`);
    }

    triggerPhotoPicker() {
      if (!this.pendantComplete()) {
        this.showError(this.pendantError,'Choose your pendant shape and color first.');
        return this.focusSection('pendant');
      }
      if (!this.originalFileInput) return;
      this.markCustomizerStarted('photo_picker');
      this.originalFileInput.value = '';
      this.originalFileInput.click();
    }

    handlePhotoFile(file) {
      this.hideError(this.photoError);
      if (!file) return;
      this.emitEvent('photo_upload_started',{ file_type:this.safeFileType(file) });
      if (!file.type.startsWith('image/') && !/\.(heic|heif)$/i.test(file.name)) {
        return this.showError(this.photoError,'Please choose a JPG, PNG, WebP, HEIC or HEIF image.');
      }
      if (this.build.photoState.url) {
        this.imageCache.delete(`local:${this.build.photoState.url}`);
        URL.revokeObjectURL(this.build.photoState.url);
      }
      this.build.originalFile = file;
      this.build.productionFile = file;
      this.build.productionPromise = null;
      this.build.photoConfirmed = false;
      this.build.photoState = { url:URL.createObjectURL(file), renderable:false, zoom:1, offsetX:0, offsetY:0, adjusted:false };
      this.resetPhotoEdits();
      this.invalidatePreview();
      this.photoLayer.onload = () => {
        this.photoLayer.onload = null;
        this.photoLayer.onerror = null;
        this.build.photoState.renderable = true;
        this.build.photoState.aspect = (this.photoLayer.naturalWidth || 1) / Math.max(1,this.photoLayer.naturalHeight || 1);
        this.build.productionPromise = this.deferProductionPhoto(file,this.photoLayer);
        this.setPhotoEditing(true);
        this.showInteractionCue();
        this.updateAll();
        this.persistProgress('photo');
        this.emitEvent('photo_uploaded');
      };
      this.photoLayer.onerror = () => {
        this.photoLayer.onload = null;
        this.photoLayer.onerror = null;
        this.build.photoState.renderable = false;
        this.setPhotoEditing(false);
        this.showError(this.photoError,'This photo could not be previewed. Please try a JPG, PNG or WebP image.');
        this.updateAll();
      };
      this.photoLayer.src = this.build.photoState.url;
    }

    confirmPhoto() {
      if (!this.build.photoState.renderable) return this.showPhotoRequiredAlert();
      this.build.photoConfirmed = true;
      this.hideError(this.photoError);
      this.setPhotoEditing(false);
      this.updateAll();
      this.preparePreview();
      this.persistProgress('chain');
      this.emitEvent('photo_confirmed');
    }

    editPhotoFromPreview() {
      if (!this.build.photoState.renderable) {
        if (this.build.pendantChosen) this.focusSection('photo');
        return;
      }
      if (!this.build.photoConfirmed) return;
      this.build.photoConfirmed = false;
      this.setPhotoEditing(true);
      this.updateAll();
      this.emitEvent('photo_edit_reopened');
    }

    setPhotoEditing(editing) {
      this.photoEditing = Boolean(editing && this.build.photoState.renderable && !this.build.photoConfirmed);
      this.classList.toggle('is-photo-editing',this.photoEditing);
      this.classList.toggle('is-photo-locked',Boolean(this.build.photoState.renderable && !this.photoEditing));
      document.body.classList.toggle('cgl-pc-photo-editing',this.photoEditing);
      if (this.photoPrimaryButton && this.photoEditorAction && this.photoPrimaryHome) {
        const destination = this.photoEditing ? this.photoEditorAction : this.photoPrimaryHome;
        if (this.photoPrimaryButton.parentElement !== destination) destination.appendChild(this.photoPrimaryButton);
        this.photoEditorAction.hidden = !this.photoEditing;
      }
      this.updateDockVisibility?.();
      if (this.resetButton) this.resetButton.hidden = !this.photoEditing;
      if (this.interactionCue) this.interactionCue.hidden = !this.photoEditing || Boolean(this.build.photoState.adjusted);
      if (this.photoAssurance) this.photoAssurance.hidden = !this.photoEditing || !this.build.photoState.adjusted;
    }

    showInteractionCue() {
      if (!this.interactionCue || !this.photoEditing) return;
      window.clearTimeout(this.cueTimer);
      this.interactionCue.hidden = false;
      this.cueTimer = window.setTimeout(() => { if (this.interactionCue) this.interactionCue.hidden = true; },2200);
    }

    showPhotoAssurance() {
      this.build.photoState.adjusted = true;
      if (this.interactionCue) this.interactionCue.hidden = true;
      if (this.photoAssurance) this.photoAssurance.hidden = false;
    }

    resetPhotoTransform(schedule = true) {
      Object.assign(this.build.photoState,{ zoom:1, offsetX:0, offsetY:0, adjusted:false });
      this.renderPhotoTransform();
      this.invalidatePreview();
      this.showInteractionCue();
      if (schedule) this.schedulePreview();
    }

    renderPhotoTransform() {
      const state = this.build.photoState;
      if (!this.photoLayer || !this.photoWindow) return;
      const imageAspect = Number(state.aspect || (this.photoLayer.naturalWidth / Math.max(1,this.photoLayer.naturalHeight)) || 1);
      const frameAspect = this.photoWindow.clientWidth / Math.max(1,this.photoWindow.clientHeight);
      if (imageAspect >= frameAspect) {
        this.photoLayer.style.width = `${(imageAspect / frameAspect) * 100}%`;
        this.photoLayer.style.height = '100%';
      } else {
        this.photoLayer.style.width = '100%';
        this.photoLayer.style.height = `${(frameAspect / imageAspect) * 100}%`;
      }
      this.photoLayer.style.left = `calc(50% + ${state.offsetX * 100}%)`;
      this.photoLayer.style.top = `calc(50% + ${state.offsetY * 100}%)`;
      this.photoLayer.style.transform = `translate(-50%, -50%) scale(${state.zoom})`;
    }

    onPointerDown(event) {
      if (!this.build.photoState.renderable || !this.photoEditing) return;
      event.preventDefault();
      this.stage.setPointerCapture?.(event.pointerId);
      this.pointers.set(event.pointerId,{ x:event.clientX, y:event.clientY });
      if (this.pointers.size === 2) {
        const [first,second] = [...this.pointers.values()];
        this.pinchOrigin = { distance:this.distance(first,second), zoom:this.build.photoState.zoom };
      }
    }

    onPointerMove(event) {
      if (!this.build.photoState.renderable || !this.photoEditing || !this.pointers.has(event.pointerId)) return;
      event.preventDefault();
      const previous = this.pointers.get(event.pointerId);
      this.pointers.set(event.pointerId,{ x:event.clientX, y:event.clientY });
      if (this.pointers.size >= 2 && this.pinchOrigin) {
        const [first,second] = [...this.pointers.values()];
        this.build.photoState.zoom = this.clamp(this.pinchOrigin.zoom * this.distance(first,second) / Math.max(1,this.pinchOrigin.distance),.25,4);
      } else if (this.pointers.size === 1 && previous && this.photoWindow) {
        const rect = this.photoWindow.getBoundingClientRect();
        this.build.photoState.offsetX = this.clamp(this.build.photoState.offsetX + (event.clientX - previous.x) / Math.max(1,rect.width),-3,3);
        this.build.photoState.offsetY = this.clamp(this.build.photoState.offsetY + (event.clientY - previous.y) / Math.max(1,rect.height),-3,3);
      }
      if (!this.build.photoState.adjusted) this.showPhotoAssurance();
      if (!this.photoAdjustmentTracked) {
        this.photoAdjustmentTracked = true;
        this.emitEvent('photo_adjusted');
      }
      this.renderPhotoTransform();
      this.invalidatePreview();
    }

    onPointerUp(event) {
      if (!this.pointers.has(event.pointerId)) return;
      this.pointers.delete(event.pointerId);
      this.stage.releasePointerCapture?.(event.pointerId);
      if (this.pointers.size < 2) this.pinchOrigin = null;
      if (!this.pointers.size) this.schedulePreview();
    }

    distance(first,second) { return Math.hypot(second.x - first.x,second.y - first.y); }

    updateAll() {
      this.classList.toggle('is-silver',this.build.color === 'Silver');
      this.updateControls();
      this.updatePreview();
      this.updateSections();
      this.updateVariantAndPrices();
      this.updateDock();
      this.updateRecap();
      this.updateActionButtons();
      this.trackCompletionIfReady();
    }

    updateControls() {
      this.querySelectorAll('[data-cgl-option]').forEach((input) => {
        const selected = this.build.selected[input.dataset.cglOption];
        if (input.dataset.cglOption === 'Pendant') input.checked = this.build.pendantChosen && selected === input.value;
        else if (input.dataset.cglOption === 'Material') input.checked = this.build.materialChosen && selected === input.value;
        else input.checked = selected === input.value;
      });
      this.querySelectorAll('[data-cgl-color]').forEach((input) => { input.checked = this.build.colorChosen && this.build.color === input.value; });
      this.querySelectorAll('[data-cgl-length]').forEach((input) => { input.checked = this.build.length === input.value; });
    }

    updatePreview() {
      const hasPhoto = Boolean(this.build.photoState.renderable && this.build.photoState.url);
      if (this.productPlaceholder) this.productPlaceholder.hidden = this.build.pendantChosen;
      if (hasPhoto && this.photoLayer.getAttribute('src') !== this.build.photoState.url) this.photoLayer.src = this.build.photoState.url;
      if (!hasPhoto) this.photoLayer?.removeAttribute('src');
      this.renderPhotoTransform();
      this.setPhotoEditing(hasPhoto && !this.build.photoConfirmed);
      if (this.photoComposite) this.photoComposite.dataset.pendant = this.build.selected.Pendant;
      if (this.pendantComposite) this.pendantComposite.dataset.pendant = this.build.selected.Pendant;
      const pendantArtwork = this.artworkFor('pendant',this.build.selected.Pendant);
      const chainArtwork = this.artworkFor('chain',this.build.selected.Chain);
      const shouldLoadArtwork = this.build.pendantChosen || hasPhoto;
      this.setLayerImage(this.pendantLayer,shouldLoadArtwork ? pendantArtwork.source : '');
      this.setLayerImage(this.chainLayer,shouldLoadArtwork ? chainArtwork.source : '');
      if (this.pendantLayer) this.pendantLayer.dataset.nativeSilver = String(pendantArtwork.nativeSilver);
      if (this.chainLayer) this.chainLayer.dataset.nativeSilver = String(chainArtwork.nativeSilver);
      const hasArtwork = Boolean(pendantArtwork.source && chainArtwork.source);
      if (this.stageEmpty) this.stageEmpty.hidden = hasArtwork;

      if (this.photoPrimaryButton) {
        this.photoPrimaryButton.hidden = this.build.photoConfirmed;
        this.photoPrimaryButton.classList.toggle('is-confirm',hasPhoto && !this.build.photoConfirmed);
      }
      if (this.photoPrimaryLabel) this.photoPrimaryLabel.textContent = hasPhoto ? 'USE THIS PHOTO' : 'UPLOAD YOUR PHOTO';
      if (this.photoConfirmedRow) this.photoConfirmedRow.hidden = !this.build.photoConfirmed;
      if (this.photoEditsWrap) this.photoEditsWrap.hidden = !this.build.photoConfirmed;
      if (this.previewCard) {
        this.previewCard.tabIndex = this.build.photoConfirmed ? 0 : -1;
        this.previewCard.setAttribute('aria-disabled',String(!this.build.photoConfirmed));
      }
      this.querySelector('[data-cgl-upload-icon]')?.toggleAttribute('hidden',hasPhoto);
      this.querySelector('[data-cgl-confirm-icon]')?.toggleAttribute('hidden',!hasPhoto);
      this.updateThumbnailImages();
    }

    updateSections() {
      const pendantComplete = this.pendantComplete();
      const states = {
        pendant:{ locked:false, complete:pendantComplete },
        photo:{ locked:!pendantComplete, complete:this.build.photoConfirmed },
        chain:{ locked:!this.build.photoConfirmed, complete:this.build.photoConfirmed },
        material:{ locked:!this.build.photoConfirmed, complete:this.build.materialChosen }
      };
      const current = !pendantComplete ? 'pendant' : !this.build.photoConfirmed ? 'photo' : !this.build.materialChosen ? 'material' : '';
      this.querySelectorAll('[data-cgl-section]').forEach((section) => {
        const state = states[section.dataset.cglSection];
        if (!state) return;
        section.classList.toggle('is-locked',state.locked);
        section.classList.toggle('is-complete',state.complete);
        section.classList.toggle('is-active',section.dataset.cglSection === current && !state.locked);
        section.setAttribute('aria-disabled',String(state.locked));
      });
    }

    pendantComplete() {
      return Boolean(this.build.pendantChosen && this.build.colorChosen);
    }

    finishComplete() {
      return Boolean(this.pendantComplete() && this.build.materialChosen);
    }

    getOptionNames() {
      return Array.isArray(this.product.options) ? this.product.options.map((option) => typeof option === 'string' ? option : option.name) : [];
    }

    findVariant(selection) {
      const optionNames = this.getOptionNames();
      if (!optionNames.length || !Array.isArray(this.product.variants)) return null;
      return this.product.variants.find((variant) => optionNames.every((name,index) => selection[name] == null || variant.options[index] === selection[name])) || null;
    }

    variantFor(material,pendant = this.build.selected.Pendant,chain = this.build.selected.Chain) {
      return this.findVariant({ Pendant:pendant, Chain:chain, Material:material });
    }

    updateVariantAndPrices() {
      this.currentVariant = this.findVariant(this.build.selected);
      if (this.currentVariant && this.variantInput) this.variantInput.value = this.currentVariant.id;
      const signature = this.variantFor('Signature');
      const fine = this.variantFor('Fine Jewelry');
      const activeStyleCard = [...this.querySelectorAll('[data-cgl-style-card]')].find((card) => card.querySelector('[data-cgl-option="Pendant"]')?.value === this.build.selected.Pendant);
      const fineFallback = Number(activeStyleCard?.dataset.cglFineBase || 22900) + this.chainFallback(this.build.selected.Chain);
      this.setText('[data-cgl-material-price="Signature"]',signature ? this.formatMoney(signature.price) : 'Unavailable');
      this.setText('[data-cgl-material-price="Fine Jewelry"]',fine ? this.formatMoney(fine.price) : this.formatMoney(fineFallback));
      this.setText('[data-cgl-intro-price]',this.formatMoney(this.currentPrice()));
      const compareAt = Number(this.currentVariant?.compare_at_price || 0);
      const showSale = compareAt > this.currentPrice();
      const introCompare = this.querySelector('[data-cgl-intro-compare]');
      const introSale = this.querySelector('[data-cgl-intro-sale]');
      if (introCompare) {
        introCompare.hidden = !showSale;
        if (showSale) introCompare.textContent = this.formatMoney(compareAt);
      }
      if (introSale) introSale.hidden = !showSale;
      this.updateChoicePriceLabels();
    }

    chainFallback(chain) {
      const input = [...this.querySelectorAll('[data-cgl-option="Chain"]')].find((item) => item.value === chain);
      return Number(input?.closest('.cgl-pc__visual-choice')?.querySelector('[data-cgl-chain-upcharge]')?.dataset.cglChainUpcharge || 0);
    }

    updateChoicePriceLabels() {
      this.querySelectorAll('[data-cgl-style-card]').forEach((card) => {
        const input = card.querySelector('[data-cgl-option="Pendant"]');
        const label = card.querySelector('[data-cgl-signature-upcharge]');
        if (!input || !label) return;
        if (this.build.selected.Material === 'Fine Jewelry') {
          const variant = this.variantFor('Fine Jewelry',input.value,this.build.selected.Chain);
          const fallback = Number(card.dataset.cglFineBase || 0) + this.chainFallback(this.build.selected.Chain);
          label.textContent = variant ? this.formatMoney(variant.price) : this.formatMoney(fallback);
          label.hidden = false;
        } else {
          const difference = Number(label.dataset.cglSignatureUpcharge || 0);
          label.textContent = difference > 0 ? `+${this.formatMoney(difference)}` : '';
          label.hidden = difference <= 0;
        }
      });
      this.querySelectorAll('[data-cgl-chain-upcharge]').forEach((label) => {
        const difference = Number(label.dataset.cglChainUpcharge || 0);
        label.textContent = difference > 0 ? `+${this.formatMoney(difference)}` : '';
        label.hidden = difference <= 0;
      });
    }

    currentPrice() {
      if (this.currentVariant) return Number(this.currentVariant.price || 0);
      const styleCard = [...this.querySelectorAll('[data-cgl-style-card]')].find((card) => card.querySelector('[data-cgl-option="Pendant"]')?.value === this.build.selected.Pendant);
      if (this.build.selected.Material === 'Fine Jewelry') return Number(styleCard?.dataset.cglFineBase || 22900) + this.chainFallback(this.build.selected.Chain);
      const signatureBase = Number(this.product.variants?.find((variant) => variant.options?.includes('Signature'))?.price || 2900);
      const pendantExtra = Number(styleCard?.querySelector('[data-cgl-signature-upcharge]')?.dataset.cglSignatureUpcharge || 0);
      return signatureBase + pendantExtra + this.chainFallback(this.build.selected.Chain);
    }

    updateDock() {
      const title = this.build.pendantChosen ? `${this.build.selected.Pendant} Photo Pendant` : 'Custom Photo Pendant';
      const details = `${this.build.color} · ${this.build.selected.Material} · ${this.build.selected.Chain} · ${this.build.length}`;
      const price = this.formatMoney(this.currentPrice());
      this.setText('[data-cgl-dock-title]',title);
      this.setText('[data-cgl-dock-details]',details);
      this.setText('[data-cgl-dock-price]',price);
      this.setText('[data-cgl-sticky-price]',price);
    }

    isReady() {
      return Boolean(this.finishComplete() && this.build.photoConfirmed && this.build.photoState.renderable && this.currentVariant?.available);
    }

    updateRecap() {
      const ready = this.isReady();
      if (this.recap) this.recap.hidden = !ready;
      if (!ready) this.setStickyVisible(false);
      this.setText('[data-cgl-recap-shape]',`${this.build.selected.Pendant} Photo Pendant`);
      this.setText('[data-cgl-recap-details]',`${this.build.color} · ${this.build.selected.Material}\n${this.build.selected.Chain} · ${this.build.length}`);
      this.setText('[data-cgl-recap-price]',this.formatMoney(this.currentPrice()));
      if (ready && this.build.previewUrl && this.recapImage?.getAttribute('src') !== this.build.previewUrl) this.recapImage.src = this.build.previewUrl;
      if (ready && !this.build.previewUrl) this.preparePreview();
    }

    updateActionButtons() {
      if (this.loading) return;
      const available = Boolean(this.currentVariant?.available);
      this.actionButtons.forEach((button) => { button.disabled = !available; });
    }

    handleAddToCart() {
      if (this.loading) return;
      this.emitEvent('add_to_cart_clicked',{ ready:this.isReady(), missing_step:this.firstMissingStep() });
      if (!this.build.pendantChosen) {
        this.showError(this.pendantError,'Choose your pendant shape first.');
        return this.focusSection('pendant');
      }
      if (!this.build.colorChosen) {
        this.showError(this.pendantError,'Choose your pendant color to continue.');
        return this.focusSection('pendant');
      }
      if (!this.build.photoConfirmed) return this.showPhotoRequiredAlert();
      if (!this.build.materialChosen) return this.focusSection('material');
      const otherSelected = this.photoEditInputs.find((input) => input.dataset.cglPhotoEditReveal === 'other')?.checked;
      if (otherSelected && !this.photoEditOther?.value.trim()) {
        this.photoEditsWrap.open = true;
        this.showError(this.photoError,'Add one short sentence for your designer.');
        this.photoEditOther?.focus({ preventScroll:true });
        return;
      }
      if (!this.currentVariant?.available) {
        this.showError(this.formError,'That combination is currently unavailable. Please choose another option.');
        this.emitEvent('add_to_cart_error',{ error_stage:'validation', error_code:'variant_unavailable' });
        return;
      }
      this.submitToCart();
    }

    showPhotoRequiredAlert() {
      this.showError(this.photoError,'Upload and confirm your photo to continue.');
      this.focusSection('photo');
    }

    focusSection(name) {
      this.querySelector(`[data-cgl-section="${name}"]`)?.scrollIntoView({ behavior:'smooth', block:'center' });
    }

    invalidatePreview() {
      if (this.build.previewUrl) URL.revokeObjectURL(this.build.previewUrl);
      this.build.previewUrl = '';
      this.build.previewCacheKey = '';
      this.build.previewFile = null;
      if (this.recapImage) this.recapImage.removeAttribute('src');
      window.clearTimeout(this.previewTimer);
    }

    getPreviewKey() {
      const file = this.build.originalFile;
      if (!file) return '';
      return [file.name,file.size,file.lastModified,this.build.color,this.build.selected.Pendant,this.build.selected.Chain,this.build.photoState.zoom.toFixed(4),this.build.photoState.offsetX.toFixed(4),this.build.photoState.offsetY.toFixed(4)].join('|');
    }

    schedulePreview() {
      if (!this.build.photoState.renderable) return;
      window.clearTimeout(this.previewTimer);
      this.previewTimer = window.setTimeout(() => {
        const prepare = () => this.preparePreview();
        if ('requestIdleCallback' in window) window.requestIdleCallback(prepare,{ timeout:700 });
        else prepare();
      },220);
    }

    preparePreview() {
      if (!this.build.photoState.renderable) return Promise.resolve(null);
      return this.attachGeneratedPreview(true).then((file) => {
        if (this.recapImage && this.build.previewUrl) this.recapImage.src = this.build.previewUrl;
        return file;
      }).catch(() => null);
    }

    async submitToCart(options = {}) {
      this.hideError(this.formError);
      this.setLoading(true);
      const editingKey = this.editingCartKey;
      try {
        this.setText('[data-cgl-buybar-status]','PREPARING YOUR PREVIEW…');
        const [preview,productionPhoto] = await Promise.all([
          this.attachGeneratedPreview(false),
          this.getProductionPhoto()
        ]);
        if (editingKey) this.cglCustomizationId = this.makeAnonymousId('cglc');
        const data = this.buildCartFormData(preview,productionPhoto);
        const addedResult = await this.uploadCart(data);
        let result = addedResult;
        if (editingKey) result = await this.removeCartItem(editingKey);
        this.lastAddedKey = addedResult?.key || this.lastAddedKey;
        this.editingCartKey = '';
        this.emitEvent('add_to_cart_success',{ cart_quantity:1 });
        this.setUploadProgress(100);
        this.setText('[data-cgl-buybar-status]','✓ YOUR PENDANT IS IN THE BAG');
        this.refreshCartBubble(result);
        this.setLoading(false);
        this.openPostAtcOffer(editingKey ? 0 : 1);
      } catch (error) {
        console.error(error);
        this.emitEvent('add_to_cart_error',{ error_stage:'cart_request', error_code:this.safeErrorCode(error) });
        this.showError(this.formError,error.message || 'Something went wrong. Please try again.');
        this.setLoading(false);
      }
    }

    buildCartFormData(preview,productionPhoto) {
      const data = new FormData();
      data.append('id',String(this.currentVariant.id));
      data.append('quantity','1');
      data.append('properties[Color]',this.build.color);
      data.append('properties[Length]',this.build.length);
      data.append('properties[Estimated delivery]',this.deliveryEstimate);
      const selectedEdits = this.photoEditInputs
        .filter((input) => input.checked && !input.dataset.cglPhotoEditReveal)
        .map((input) => input.value);
      if (selectedEdits.length) data.append('properties[Photo edits]',selectedEdits.join(', '));
      if (this.photoEditInputs.find((input) => input.dataset.cglPhotoEditReveal === 'other')?.checked && this.photoEditOther?.value.trim()) {
        data.append('properties[Photo request]',this.photoEditOther.value.trim());
      }
      data.append('properties[Preview]',preview,preview.name);
      data.append('properties[_Original Photo]',productionPhoto,productionPhoto.name);
      data.append('properties[_Customizer Version]','V45');
      data.append('properties[_Customization ID]',this.cglCustomizationId);
      data.append('sections','cart-drawer,cart-icon-bubble');
      data.append('sections_url',window.location.pathname);
      return data;
    }

    getProductionPhoto() {
      if (this.build.productionPromise) return this.build.productionPromise;
      return Promise.resolve(this.build.productionFile || this.build.originalFile);
    }

    deferProductionPhoto(file,image) {
      return new Promise((resolve) => {
        window.clearTimeout(this.productionTimer);
        this.productionTimer = window.setTimeout(() => {
          this.productionTimer = null;
          this.prepareProductionPhoto(file,image).then(resolve);
        },80);
      });
    }

    async prepareProductionPhoto(file,image) {
      try {
        const maxEdge = Math.max(image.naturalWidth || 0,image.naturalHeight || 0);
        const shouldOptimize = file.size > 3 * 1024 * 1024 || maxEdge > 3000;
        if (!shouldOptimize || !maxEdge) {
          if (this.build.originalFile === file) this.build.productionFile = file;
          return file;
        }
        const scale = Math.min(1,3000 / maxEdge);
        const width = Math.max(1,Math.round(image.naturalWidth * scale));
        const height = Math.max(1,Math.round(image.naturalHeight * scale));
        let source = image;
        if ('createImageBitmap' in window) {
          try { source = await window.createImageBitmap(file,{ resizeWidth:width, resizeHeight:height, resizeQuality:'high' }); }
          catch (error) { source = image; }
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d',{ alpha:false });
        if (!context) return file;
        context.fillStyle = '#fff';
        context.fillRect(0,0,width,height);
        context.drawImage(source,0,0,width,height);
        if (source !== image && typeof source.close === 'function') source.close();
        const blob = await new Promise((resolve,reject) => canvas.toBlob((result) => result ? resolve(result) : reject(new Error('Photo optimization failed.')),'image/jpeg',.9));
        canvas.width = canvas.height = 1;
        const stem = (file.name || 'custom-photo').replace(/\.[^.]+$/,'').replace(/[^a-z0-9_-]+/gi,'-');
        const optimized = new File([blob],`${stem}-production.jpg`,{ type:'image/jpeg', lastModified:Date.now() });
        if (this.build.originalFile === file) this.build.productionFile = optimized;
        return optimized;
      } catch (error) {
        console.warn('CustomGLD kept the original photo because optimization was unavailable.',error);
        if (this.build.originalFile === file) this.build.productionFile = file;
        return file;
      }
    }

    uploadCart(data) {
      return new Promise((resolve,reject) => {
        const request = new XMLHttpRequest();
        request.open('POST',`${window.Shopify?.routes?.root || '/'}cart/add.js`);
        request.setRequestHeader('X-Requested-With','XMLHttpRequest');
        request.responseType = 'json';
        request.upload.addEventListener('progress',(event) => {
          if (!event.lengthComputable) return;
          const progress = event.loaded / event.total;
          this.setUploadProgress(Math.max(2,Math.round(progress * 96)));
          this.setText('[data-cgl-buybar-status]',progress < .5 ? 'SAVING YOUR MEMORY…' : 'LOCKING IN THE DETAILS…');
        });
        request.addEventListener('load',() => {
          const result = request.response || {};
          if (request.status >= 200 && request.status < 300) resolve(result);
          else reject(new Error(result.description || result.message || 'Could not add this pendant to your cart.'));
        });
        request.addEventListener('error',() => reject(new Error('Your connection dropped. Please check your cart before trying again.')));
        request.send(data);
      });
    }

    async removeCartItem(key) {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`,{
        method:'POST',
        credentials:'same-origin',
        headers:{ 'Content-Type':'application/json', Accept:'application/json', 'X-Requested-With':'XMLHttpRequest' },
        body:JSON.stringify({ id:key, quantity:0, sections:['cart-drawer','cart-icon-bubble'], sections_url:window.location.pathname })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Your edited pendant was added, but the original could not be removed. Please check your cart.');
      return result;
    }

    refreshCartBubble(result) {
      const html = result?.sections?.['cart-icon-bubble'];
      const current = document.getElementById('cart-icon-bubble');
      if (!html || !current) return;
      const replacement = new DOMParser().parseFromString(html,'text/html').getElementById('cart-icon-bubble');
      if (replacement) current.innerHTML = replacement.innerHTML;
    }

    openPostAtcOffer(quantityDelta = 1) {
      if (!this.postAtcOffer || !this.offerDialog) {
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        return;
      }
      if (this.offerPreviewUrl) URL.revokeObjectURL(this.offerPreviewUrl);
      this.offerPreviewUrl = this.build.previewFile ? URL.createObjectURL(this.build.previewFile) : (this.build.previewUrl || this.recapImage?.src || '');
      if (this.offerItemImage && this.offerPreviewUrl) this.offerItemImage.src = this.offerPreviewUrl;
      this.showOfferDecision(false);
      this.postAtcOffer.hidden = false;
      document.body.classList.add('cgl-pc-offer-open');
      document.addEventListener('keydown',this.offerKeydown);
      this.offerDialog.focus({ preventScroll:true });
      const expectedQuantity = Math.max(1,Number(this.offerEligibleQuantity || 0) + quantityDelta);
      this.updateOfferState(expectedQuantity);
      this.emitEvent('post_atc_offer_view',{ eligible_cart_quantity:expectedQuantity });
      this.loadOfferCartState();
    }

    async loadOfferCartState() {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`,{ credentials:'same-origin', cache:'no-store', headers:{ Accept:'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        const eligibleQuantity = (cart.items || []).reduce((total,item) => {
          return this.offerEligibleIds.includes(Number(item.product_id)) ? total + Number(item.quantity || 0) : total;
        },0);
        this.updateOfferState(Math.max(1,eligibleQuantity),Number(cart.total_price || 0));
      } catch (error) {
        console.warn('CustomGLD could not refresh offer progress.',error);
      }
    }

    updateOfferState(quantity,cartValue = 0) {
      const previousQuantity = Number(this.offerEligibleQuantity || 0);
      this.offerEligibleQuantity = quantity;
      const title = this.querySelector('[data-cgl-offer-title]');
      const copy = this.querySelector('[data-cgl-offer-copy]');
      const freeLabel = this.querySelector('[data-cgl-offer-free-label]');
      this.offerDialog?.classList.toggle('is-complete',quantity >= 3);
      this.offerBenefits?.classList.toggle('is-unlocked',quantity >= 2);

      if (this.offerSecondSlot) {
        this.offerSecondSlot.classList.toggle('is-filled',quantity >= 2);
        this.offerSecondSlot.disabled = quantity >= 2;
        this.offerSecondSlot.setAttribute('aria-expanded',String(this.offerPickerTarget === 'second' && !this.offerShop?.hidden));
        const plus = this.offerSecondSlot.querySelector('.cgl-pc__offer-slot-plus');
        if (plus) plus.textContent = quantity >= 2 ? '✓' : '+';
        const label = this.offerSecondSlot.querySelector('b');
        if (label) label.textContent = quantity >= 2 ? 'Added' : 'Add another';
      }

      if (this.offerFreeSlot) {
        this.offerFreeSlot.classList.toggle('is-unlocked',quantity >= 2);
        this.offerFreeSlot.classList.toggle('is-filled',quantity >= 3);
        this.offerFreeSlot.disabled = quantity < 2 || quantity >= 3;
        this.offerFreeSlot.setAttribute('aria-expanded',String(this.offerPickerTarget === 'free' && !this.offerShop?.hidden));
        const plus = this.offerFreeSlot.querySelector('.cgl-pc__offer-slot-plus');
        if (plus) plus.textContent = quantity >= 3 ? '✓' : '+';
        if (previousQuantity > 0 && previousQuantity < 2 && quantity >= 2) {
          this.offerFreeSlot.classList.remove('is-celebrating');
          void this.offerFreeSlot.offsetWidth;
          this.offerFreeSlot.classList.add('is-celebrating');
          window.setTimeout(() => this.offerFreeSlot?.classList.remove('is-celebrating'),900);
        }
      }

      if (quantity >= 3) {
        if (title) title.textContent = 'Deal unlocked';
        if (copy) copy.innerHTML = '<span>Your three eligible pieces are ready.</span><span>Your lowest-priced piece is <strong>FREE.</strong></span>';
        if (freeLabel) freeLabel.textContent = 'Free piece';
        this.closeOfferPicker();
        this.emitEventOnce('b2g1_completed',{ eligible_cart_quantity:quantity, cart_value:cartValue });
      } else if (quantity === 2) {
        if (title) title.textContent = 'Your 3rd piece is FREE';
        if (copy) copy.innerHTML = '<span>Choose one more eligible piece.</span><span>Your third piece is <strong>FREE.</strong></span>';
        if (freeLabel) freeLabel.textContent = 'Add your FREE piece';
        if (this.offerPickerTarget === 'second') this.closeOfferPicker();
        this.emitEventOnce('free_item_unlocked',{ eligible_cart_quantity:quantity, cart_value:cartValue });
      } else {
        if (title) title.textContent = 'Buy 2, Get 1 FREE';
        if (copy) copy.innerHTML = '<span>Add one more eligible piece.</span><span>Then your third is <strong>FREE.</strong></span>';
        if (freeLabel) freeLabel.textContent = 'Locked';
      }
    }

    openOfferPicker(target = 'second') {
      const quantity = Number(this.offerEligibleQuantity || 1);
      if ((target === 'second' && quantity >= 2) || (target === 'free' && (quantity < 2 || quantity >= 3))) return;
      this.offerPickerTarget = target;
      if (this.offerShopTitle) this.offerShopTitle.textContent = target === 'free' ? 'Choose your FREE piece' : 'Choose your next piece';
      if (this.offerShop) this.offerShop.hidden = false;
      this.offerDialog?.classList.add('is-choosing');
      this.offerSecondSlot?.setAttribute('aria-expanded',String(target === 'second'));
      this.offerFreeSlot?.setAttribute('aria-expanded',String(target === 'free'));
      this.emitEvent('post_atc_slot_clicked',{ slot:target, eligible_cart_quantity:quantity });
      window.requestAnimationFrame(() => {
        this.offerShop?.querySelector('[data-cgl-offer-product-link]')?.focus({ preventScroll:true });
      });
    }

    closeOfferPicker() {
      this.offerPickerTarget = '';
      if (this.offerShop) this.offerShop.hidden = true;
      this.offerDialog?.classList.remove('is-choosing');
      this.offerSecondSlot?.setAttribute('aria-expanded','false');
      this.offerFreeSlot?.setAttribute('aria-expanded','false');
    }

    async openOfferBuilder(productType = 'photo_pendant',options = {}) {
      const isBracelet = productType === 'photo_bracelet';
      const isSpinning = productType === 'spinning_necklace';
      this.emitEvent('post_atc_product_click',{ product_type:productType, eligible_cart_quantity:this.offerEligibleQuantity || 1, placeholder_customizer:false, embedded_customizer:isBracelet || isSpinning });
      if (!this.postAtcOffer || !this.offerBuilder || !this.offerBuilderHost || !this.form) return;
      if (isBracelet) {
        await this.openBraceletOfferBuilder();
        return;
      }
      if (isSpinning) {
        await this.openSpinningOfferBuilder();
        return;
      }
      this.offerBuilderType = productType;
      this.offerBuilderHost.classList.remove('is-bracelet','is-spinning','is-loading');
      if (this.embeddedBracelet) this.embeddedBracelet.hidden = true;
      if (this.embeddedSpinning) this.embeddedSpinning.hidden = true;
      this.offerDialog?.classList.add('is-building');
      if (this.offerBuilderTitle?.id) this.offerDialog?.setAttribute('aria-labelledby',this.offerBuilderTitle.id);
      this.classList.add('is-offer-building');
      if (this.offerMain) this.offerMain.hidden = true;
      this.offerBuilder.hidden = false;
      this.offerBuilderHost.appendChild(this.form);
      document.body.classList.add('cgl-pc-offer-open','cgl-pc-offer-builder-open');
      if (options.editing && this.lastAddedKey) this.editingCartKey = this.lastAddedKey;
      else this.editingCartKey = '';
      if (!options.preserve) this.resetForAnotherPendant();
      if (this.offerBuildingLabel) this.offerBuildingLabel.textContent = this.editingCartKey ? 'Edit your piece' : 'Customize your next piece';
      this.actionButtons.forEach((button) => {
        const label = button.querySelector('span');
        if (label) label.textContent = this.editingCartKey ? 'SAVE CHANGES' : 'ADD TO CART';
      });
      window.requestAnimationFrame(() => {
        this.offerBuilder.scrollTop = 0;
        this.offerBuilderBack?.focus({ preventScroll:true });
      });
    }

    async openBraceletOfferBuilder() {
      const productUrl = this.dataset.cglBraceletUrl;
      if (!productUrl) return;
      this.offerBuilderType = 'photo_bracelet';
      if (this.formHome && this.form?.parentElement === this.offerBuilderHost) this.formHome.after(this.form);
      if (this.embeddedSpinning) this.embeddedSpinning.hidden = true;
      this.offerDialog?.classList.add('is-building');
      if (this.offerBuilderTitle?.id) this.offerDialog?.setAttribute('aria-labelledby',this.offerBuilderTitle.id);
      this.classList.add('is-offer-building');
      if (this.offerMain) this.offerMain.hidden = true;
      this.offerBuilder.hidden = false;
      this.offerBuilderHost.classList.remove('is-spinning');
      this.offerBuilderHost.classList.add('is-bracelet');
      document.body.classList.add('cgl-pc-offer-open','cgl-pc-offer-builder-open');
      if (this.offerBuildingLabel) this.offerBuildingLabel.textContent = 'Customize your bracelet';

      if (this.embeddedBracelet?.isConnected) {
        this.embeddedBracelet.hidden = false;
        this.offerBuilderHost.classList.remove('is-loading');
        this.offerBuilder.scrollTop = 0;
        return;
      }

      this.offerBuilderHost.classList.add('is-loading');
      this.offerBuilderHost.textContent = 'Opening your bracelet customizer…';
      try {
        await this.loadOfferStylesheet(this.dataset.cglBraceletCss);
        if (!this.braceletMarkup) {
          const response = await fetch(productUrl,{ credentials:'same-origin', headers:{ Accept:'text/html','X-Requested-With':'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`Bracelet page returned ${response.status}`);
          const documentCopy = new DOMParser().parseFromString(await response.text(),'text/html');
          const customizer = documentCopy.querySelector('cgl-bracelet-customizer');
          if (!customizer) throw new Error('Bracelet customizer was not found on its product template.');
          this.braceletMarkup = customizer.outerHTML;
        }
        const template = document.createElement('template');
        template.innerHTML = this.braceletMarkup.trim();
        this.offerBuilderHost.replaceChildren(template.content.cloneNode(true));
        this.embeddedBracelet = this.offerBuilderHost.querySelector('cgl-bracelet-customizer');
        await this.loadOfferScript(this.dataset.cglBraceletJs);
        this.offerBuilderHost.classList.remove('is-loading');
        this.offerBuilder.scrollTop = 0;
        this.offerBuilderBack?.focus({ preventScroll:true });
      } catch (error) {
        this.offerBuilderHost.classList.remove('is-loading');
        const message = document.createElement('p');
        message.textContent = 'The bracelet builder could not open here.';
        const link = document.createElement('a');
        link.href = productUrl;
        link.textContent = 'Open the bracelet page';
        link.className = 'button button--primary';
        this.offerBuilderHost.replaceChildren(message,link);
        if (this.analyticsDebug) console.warn('[CustomGLD] embedded bracelet failed',error);
      }
    }

    async openSpinningOfferBuilder() {
      const productUrl = this.dataset.cglSpinningUrl;
      if (!productUrl) return;
      this.offerBuilderType = 'spinning_necklace';
      if (this.formHome && this.form?.parentElement === this.offerBuilderHost) this.formHome.after(this.form);
      if (this.embeddedBracelet) this.embeddedBracelet.hidden = true;
      this.offerDialog?.classList.add('is-building');
      if (this.offerBuilderTitle?.id) this.offerDialog?.setAttribute('aria-labelledby',this.offerBuilderTitle.id);
      this.classList.add('is-offer-building');
      if (this.offerMain) this.offerMain.hidden = true;
      this.offerBuilder.hidden = false;
      this.offerBuilderHost.classList.remove('is-bracelet');
      this.offerBuilderHost.classList.add('is-spinning');
      document.body.classList.add('cgl-pc-offer-open','cgl-pc-offer-builder-open');
      if (this.offerBuildingLabel) this.offerBuildingLabel.textContent = 'Customize your spinning necklace';
      if (this.embeddedSpinning?.isConnected) {
        this.embeddedSpinning.hidden = false;
        this.offerBuilderHost.classList.remove('is-loading');
        this.offerBuilder.scrollTop = 0;
        return;
      }
      this.offerBuilderHost.classList.add('is-loading');
      this.offerBuilderHost.textContent = 'Opening your spinning necklace customizer…';
      try {
        await this.loadOfferAsset(this.dataset.cglSpinningCss,'style','spinning');
        if (!this.spinningMarkup) {
          const response = await fetch(productUrl,{ credentials:'same-origin',headers:{ Accept:'text/html','X-Requested-With':'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`Spinning product page returned ${response.status}`);
          const documentCopy = new DOMParser().parseFromString(await response.text(),'text/html');
          const customizer = documentCopy.querySelector('cgl-spinning-customizer');
          if (!customizer) throw new Error('Spinning customizer was not found on its product template.');
          this.spinningMarkup = customizer.outerHTML;
        }
        const template = document.createElement('template');
        template.innerHTML = this.spinningMarkup.trim();
        this.offerBuilderHost.replaceChildren(template.content.cloneNode(true));
        this.embeddedSpinning = this.offerBuilderHost.querySelector('cgl-spinning-customizer');
        await this.loadOfferAsset(this.dataset.cglSpinningJs,'script','spinning');
        this.offerBuilderHost.classList.remove('is-loading');
        this.offerBuilder.scrollTop = 0;
        this.offerBuilderBack?.focus({ preventScroll:true });
      } catch (error) {
        this.offerBuilderHost.classList.remove('is-loading');
        const message = document.createElement('p'); message.textContent = 'The spinning necklace builder could not open here.';
        const link = document.createElement('a'); link.href = productUrl; link.textContent = 'Open the spinning necklace page'; link.className = 'button button--primary';
        this.offerBuilderHost.replaceChildren(message,link);
        if (this.analyticsDebug) console.warn('[CustomGLD] embedded spinning failed',error);
      }
    }

    loadOfferAsset(url,type,key) {
      if (!url) return type === 'style' ? Promise.resolve() : Promise.reject(new Error(`${key} asset URL is missing.`));
      if (type === 'script' && customElements.get(`cgl-${key}-customizer`)) return Promise.resolve();
      const selector = type === 'style' ? `link[data-cgl-${key}-style]` : `script[data-cgl-${key}-script]`;
      const existing = document.querySelector(selector);
      if (existing) return Promise.resolve();
      return new Promise((resolve,reject) => {
        const element = document.createElement(type === 'style' ? 'link' : 'script');
        if (type === 'style') { element.rel = 'stylesheet'; element.href = url; element.dataset[`cgl${key[0].toUpperCase()}${key.slice(1)}Style`] = 'true'; }
        else { element.src = url; element.async = true; element.dataset[`cgl${key[0].toUpperCase()}${key.slice(1)}Script`] = 'true'; }
        element.onload = resolve; element.onerror = () => reject(new Error(`${key} ${type} could not load.`)); document.head.appendChild(element);
      });
    }

    loadOfferStylesheet(url) {
      if (!url) return Promise.resolve();
      const existing = document.querySelector('link[data-cgl-bracelet-style]');
      if (existing) return Promise.resolve();
      return new Promise((resolve,reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        link.dataset.cglBraceletStyle = 'true';
        link.onload = resolve;
        link.onerror = () => reject(new Error('Bracelet styles could not load.'));
        document.head.appendChild(link);
      });
    }

    loadOfferScript(url) {
      if (customElements.get('cgl-bracelet-customizer')) return Promise.resolve();
      if (!url) return Promise.reject(new Error('Bracelet script URL is missing.'));
      return new Promise((resolve,reject) => {
        const existing = document.querySelector('script[data-cgl-bracelet-script]');
        if (existing) {
          existing.addEventListener('load',resolve,{ once:true });
          existing.addEventListener('error',reject,{ once:true });
          return;
        }
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.dataset.cglBraceletScript = 'true';
        script.onload = resolve;
        script.onerror = () => reject(new Error('Bracelet customizer could not load.'));
        document.head.appendChild(script);
      });
    }

    handleEmbeddedItemAdded(event) {
      event.stopPropagation();
      const detail = event.detail || {};
      this.refreshCartBubble(detail.cartResult || {});
      this.embeddedBracelet?.remove();
      this.embeddedBracelet = null;
      this.embeddedSpinning?.remove();
      this.embeddedSpinning = null;
      this.offerBuilderHost?.classList.remove('is-bracelet','is-spinning','is-loading');
      this.showOfferDecision(false);
      this.updateOfferState(Math.max(1,Number(this.offerEligibleQuantity || 1) + 1));
      this.emitEvent('post_atc_embedded_item_added',{ product_type:detail.productType || 'photo_bracelet', eligible_cart_quantity:this.offerEligibleQuantity || 1 });
      this.loadOfferCartState();
    }

    async duplicateOfferPiece() {
      if (!this.offerDuplicateButton || this.loading) return;
      const originalText = this.offerDuplicateButton.textContent;
      this.offerDuplicateButton.disabled = true;
      this.offerDuplicateButton.textContent = 'Adding…';
      this.cglCustomizationId = this.makeAnonymousId('cglc');
      this.emitEvent('post_atc_duplicate_clicked',{ eligible_cart_quantity:this.offerEligibleQuantity || 1 });
      await this.submitToCart({ duplicate:true });
      this.offerDuplicateButton.disabled = false;
      this.offerDuplicateButton.textContent = originalText;
    }

    showOfferDecision(restoreFocus = false) {
      document.body.classList.remove('cgl-pc-offer-builder-open');
      this.classList.remove('is-offer-building');
      this.offerDialog?.classList.remove('is-building');
      this.editingCartKey = '';
      this.offerBuilderType = '';
      this.actionButtons.forEach((button) => {
        const label = button.querySelector('span');
        if (label) label.textContent = 'ADD TO CART';
      });
      if (this.offerTitle?.id) this.offerDialog?.setAttribute('aria-labelledby',this.offerTitle.id);
      if (this.formHome && this.form && this.form.parentElement === this.offerBuilderHost) this.formHome.after(this.form);
      if (this.offerBuilder) this.offerBuilder.hidden = true;
      if (this.offerMain) this.offerMain.hidden = false;
      if (!restoreFocus) this.closeOfferPicker();
      if (restoreFocus) window.requestAnimationFrame(() => {
        const target = Number(this.offerEligibleQuantity || 1) >= 2 ? this.offerFreeSlot : this.offerSecondSlot;
        target?.focus({ preventScroll:true });
      });
    }

    resetForAnotherPendant() {
      if (this.build.photoState.url) URL.revokeObjectURL(this.build.photoState.url);
      if (this.build.previewUrl) URL.revokeObjectURL(this.build.previewUrl);
      this.build = {
        selected:{ Pendant:this.dataset.defaultPendant || 'Circle', Chain:'Rope', Material:'Signature' },
        color:this.dataset.defaultColor || 'Gold',
        length:'18"',
        pendantChosen:this.fixedPendant,
        colorChosen:false,
        materialChosen:true,
        photoConfirmed:false,
        photoState:{ url:'', renderable:false, aspect:1, zoom:1, offsetX:0, offsetY:0, adjusted:false },
        originalFile:null,
        productionFile:null,
        productionPromise:null,
        previewFile:null,
        previewUrl:'',
        previewCacheKey:''
      };
      this.cglCustomizationId = this.makeAnonymousId('cglc');
      this.analyticsOnce = new Set();
      this.photoAdjustmentTracked = false;
      this.currentVariant = null;
      this.originalFileInput.value = '';
      this.photoLayer?.removeAttribute('src');
      this.recapImage?.removeAttribute('src');
      this.resetPhotoEdits();
      this.setPhotoEditing(false);
      this.updateAll();
      this.persistProgress('pendant');
    }

    handleOfferKeydown(event) {
      if (this.postAtcOffer?.hidden) return;
      if (event.key === 'Escape') {
        if (this.offerDialog?.classList.contains('is-building')) {
          event.preventDefault();
          this.showOfferDecision(true);
          return;
        }
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...this.offerDialog.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    async attachGeneratedPreview(silent = false) {
      const key = this.getPreviewKey();
      if (key && key === this.build.previewCacheKey && this.build.previewFile) return this.build.previewFile;
      if (!this.build.photoState.renderable) throw new Error('Please upload a photo first.');
      if (key && key === this.previewPromiseKey && this.previewPromise) return this.previewPromise;
      const job = this.renderGeneratedPreview(key,silent);
      this.previewPromise = job;
      this.previewPromiseKey = key;
      try { return await job; }
      finally {
        if (this.previewPromise === job) {
          this.previewPromise = null;
          this.previewPromiseKey = '';
        }
      }
    }

    async renderGeneratedPreview(key,silent = false) {
      const snapshot = {
        color:this.build.color,
        pendant:this.build.selected.Pendant,
        chain:this.build.selected.Chain,
        photoUrl:this.build.photoState.url,
        photoState:{ ...this.build.photoState },
        pendantArtwork:this.artworkFor('pendant',this.build.selected.Pendant,this.build.color),
        chainArtwork:this.artworkFor('chain',this.build.selected.Chain,this.build.color)
      };
      const size = 640;
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = size;
      const context = canvas.getContext('2d');
      if (!context) throw new Error('Your browser could not create the preview. Please try Safari or Chrome.');
      context.fillStyle = '#1d1b20';
      context.fillRect(0,0,size,size);
      const [chainImage,pendantImage,customerImage] = await Promise.all([
        this.loadImage(snapshot.chainArtwork.source),
        this.loadImage(snapshot.pendantArtwork.source),
        this.loadImage(snapshot.photoUrl,false)
      ]);
      const geometry = this.pendantGeometry[snapshot.pendant] || this.pendantGeometry.Circle;
      const lift = size * -.08;
      const pendantWidth = size * geometry.width;
      const pendantHeight = pendantWidth / geometry.aspect;
      const pendantX = (size - pendantWidth) / 2;
      const pendantY = size * geometry.top + lift;
      const [left,top,width,height] = geometry.window;
      const photoX = pendantX + pendantWidth * left;
      const photoY = pendantY + pendantHeight * top;
      const photoWidth = pendantWidth * width;
      const photoHeight = pendantHeight * height;
      context.save();
      context.beginPath();
      context.rect(photoX,photoY,photoWidth,photoHeight);
      context.clip();
      this.drawCoverFree(context,customerImage,photoX,photoY,photoWidth,photoHeight,snapshot.photoState);
      context.restore();
      const isSilver = snapshot.color === 'Silver';
      this.drawArtworkLayer(context,size,isSilver && !snapshot.chainArtwork.nativeSilver,(layerContext) => {
        this.drawContain(layerContext,chainImage,0,lift,size,size);
      });
      this.drawArtworkLayer(context,size,isSilver && !snapshot.pendantArtwork.nativeSilver,(layerContext) => {
        layerContext.drawImage(pendantImage,pendantX,pendantY,pendantWidth,pendantHeight);
      });
      const blob = await new Promise((resolve,reject) => canvas.toBlob((result) => result ? resolve(result) : reject(new Error('Could not create your preview.')),'image/jpeg',.8));
      canvas.width = canvas.height = 1;
      if (key !== this.getPreviewKey()) return silent ? null : this.attachGeneratedPreview(false);
      if (typeof File === 'undefined') {
        if (silent) return null;
        throw new Error('Your browser could not attach the finished preview. Please try Safari or Chrome.');
      }
      this.build.previewFile = new File([blob],`customgld-pendant-${Date.now()}.jpg`,{ type:'image/jpeg' });
      this.build.previewCacheKey = key;
      if (this.build.previewUrl) URL.revokeObjectURL(this.build.previewUrl);
      this.build.previewUrl = URL.createObjectURL(this.build.previewFile);
      return this.build.previewFile;
    }

    loadImage(source,anonymous = true) {
      if (!source) return Promise.reject(new Error('Preview artwork is missing. Add the PNGs in this section’s settings.'));
      const cacheKey = `${anonymous ? 'cors' : 'local'}:${source}`;
      if (this.imageCache.has(cacheKey)) return this.imageCache.get(cacheKey);
      const promise = new Promise((resolve,reject) => {
        const image = new Image();
        if (anonymous) image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error('A preview image could not load. Refresh and try again.'));
        image.src = source;
      });
      this.imageCache.set(cacheKey,promise);
      promise.catch(() => this.imageCache.delete(cacheKey));
      return promise;
    }

    artworkFor(kind,name,color = this.build.color) {
      const gold = kind === 'pendant' ? this.assets.pendants : this.assets.chains;
      const silver = kind === 'pendant' ? this.assets.pendantsSilver : this.assets.chainsSilver;
      const silverSource = color === 'Silver' ? silver?.[name] : '';
      return { source:silverSource || gold?.[name] || '', nativeSilver:Boolean(silverSource) };
    }

    scheduleArtworkPreload() {
      if (navigator.connection?.saveData) return;
      const preload = () => {
        const pendant = this.artworkFor('pendant',this.build.selected.Pendant);
        const chain = this.artworkFor('chain',this.build.selected.Chain);
        Promise.allSettled([
          pendant.source ? this.loadImage(pendant.source) : Promise.resolve(),
          chain.source ? this.loadImage(chain.source) : Promise.resolve()
        ]);
      };
      if ('requestIdleCallback' in window) this.artworkIdleId = window.requestIdleCallback(preload,{ timeout:1800 });
      else this.artworkIdleId = window.setTimeout(preload,900);
    }

    drawContain(context,image,x,y,width,height) {
      const scale = Math.min(width / image.naturalWidth,height / image.naturalHeight);
      const drawWidth = image.naturalWidth * scale;
      const drawHeight = image.naturalHeight * scale;
      context.drawImage(image,x + (width - drawWidth) / 2,y + (height - drawHeight) / 2,drawWidth,drawHeight);
    }

    drawArtworkLayer(context,size,shouldGrayscale,draw) {
      if (!shouldGrayscale) {
        draw(context);
        return;
      }
      const layer = document.createElement('canvas');
      layer.width = layer.height = size;
      const layerContext = layer.getContext('2d',{ willReadFrequently:true });
      if (!layerContext) {
        draw(context);
        return;
      }
      draw(layerContext);
      const imageData = layerContext.getImageData(0,0,size,size);
      const pixels = imageData.data;
      for (let index = 0; index < pixels.length; index += 4) {
        if (!pixels[index + 3]) continue;
        const gray = Math.round(.2126 * pixels[index] + .7152 * pixels[index + 1] + .0722 * pixels[index + 2]);
        pixels[index] = gray;
        pixels[index + 1] = gray;
        pixels[index + 2] = gray;
      }
      layerContext.putImageData(imageData,0,0);
      context.drawImage(layer,0,0);
    }

    drawCoverFree(context,image,x,y,width,height,state) {
      const scale = Math.max(width / image.naturalWidth,height / image.naturalHeight) * state.zoom;
      const drawWidth = image.naturalWidth * scale;
      const drawHeight = image.naturalHeight * scale;
      context.drawImage(image,x + (width - drawWidth) / 2 + state.offsetX * width,y + (height - drawHeight) / 2 + state.offsetY * height,drawWidth,drawHeight);
    }

    updateThumbnailImages() {
      const color = this.build.color === 'Silver' ? 'silver' : 'gold';
      this.thumbnailImages.forEach((image) => {
        const source = color === 'silver' ? image.dataset.silverSrc : image.dataset.goldSrc;
        if (!source) return;
        image.dataset.primarySrc = source;
        if (this.failedThumbnailSources.has(source)) return this.useThumbnailFallback(image);
        image.hidden = false;
        image.classList.remove('is-fallback');
        image.closest('.cgl-pc__choice-image')?.classList.remove('is-fallback','is-missing');
        if (image.getAttribute('src') !== source) image.src = source;
      });
    }

    setupThumbnailFallbacks() {
      this.thumbnailImages.forEach((image) => {
        image.dataset.primarySrc = image.getAttribute('src') || '';
        image.addEventListener('error',() => {
          if (image.classList.contains('is-fallback')) image.dataset.fallbackFailed = 'true';
          else if (image.dataset.primarySrc) this.failedThumbnailSources.add(image.dataset.primarySrc);
          this.useThumbnailFallback(image);
        });
        if (image.complete && !image.naturalWidth) queueMicrotask(() => this.useThumbnailFallback(image));
      });
    }

    useThumbnailFallback(image) {
      const wrapper = image.closest('.cgl-pc__choice-image');
      const fallback = image.dataset.fallbackSrc;
      if (fallback && image.dataset.fallbackFailed !== 'true') {
        image.hidden = false;
        if (!image.classList.contains('is-fallback')) { image.classList.add('is-fallback'); image.src = fallback; }
        wrapper?.classList.add('is-fallback');
      } else {
        image.hidden = true;
        wrapper?.classList.add('is-missing');
      }
    }

    setLayerImage(image,source) {
      if (!image) return;
      if (!source) { image.removeAttribute('src'); image.hidden = true; }
      else { if (image.getAttribute('src') !== source) image.src = source; image.hidden = false; }
    }

    findDockTrigger() {
      const ownSection = this.closest('.shopify-section');
      let sibling = ownSection?.previousElementSibling || null;
      while (sibling) {
        const productInfo = sibling.matches?.('product-info,.product__info-container')
          ? sibling
          : sibling.querySelector?.('product-info,.product__info-container');
        if (productInfo) {
          const priceBlock = productInfo.querySelector?.('[id^="price-"],.product__info-container > .price,.product__info-container .price');
          const titleBlock = productInfo.querySelector?.('.product__title,h1');
          return priceBlock || titleBlock || productInfo;
        }
        sibling = sibling.previousElementSibling;
      }
      return null;
    }

    initDockBehavior() {
      if (!this.dock) return;
      this.dockTrigger = this.productIntro || this.findDockTrigger();
      this.updateDockVisibility = () => {
        const boundary = this.productIntro
          ? this.productIntro.getBoundingClientRect().top
          : this.dockTrigger
            ? this.dockTrigger.getBoundingClientRect().bottom
            : this.getBoundingClientRect().top;
        const visible = this.photoEditing || boundary <= 0;
        this.classList.toggle('is-dock-sticky',visible);
        this.dock.setAttribute('aria-hidden',String(!visible));
      };
      this.dockScrollFallback = () => {
        if (this.dockFrame) return;
        this.dockFrame = window.requestAnimationFrame(() => {
          this.dockFrame = null;
          this.updateDockVisibility();
        });
      };
      window.addEventListener('scroll',this.dockScrollFallback,{ passive:true });
      window.addEventListener('resize',this.dockScrollFallback,{ passive:true });
      this.updateDockVisibility();
    }

    initStickyBuybar() {
      if (!this.naturalBuybar || !this.stickyBuybar) return;
      const update = () => {
        const rect = this.naturalBuybar.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) this.naturalCtaSeen = true;
        this.setStickyVisible(Boolean(this.isReady() && this.naturalCtaSeen && rect.bottom < 0));
      };
      this.buybarFallback = () => {
        if (this.buybarFrame) return;
        this.buybarFrame = requestAnimationFrame(() => { this.buybarFrame = null; update(); });
      };
      window.addEventListener('scroll',this.buybarFallback,{ passive:true });
      if ('IntersectionObserver' in window) {
        this.buybarObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (entry.isIntersecting) this.naturalCtaSeen = true;
          this.setStickyVisible(Boolean(this.isReady() && this.naturalCtaSeen && !entry.isIntersecting && entry.boundingClientRect.bottom < 0));
        },{ threshold:.15 });
        this.buybarObserver.observe(this.naturalBuybar);
      }
    }

    setStickyVisible(visible) {
      if (!this.stickyBuybar) return;
      this.stickyBuybar.classList.toggle('is-visible',visible);
      this.stickyBuybar.setAttribute('aria-hidden',String(!visible));
    }

    setLoading(loading) {
      this.loading = loading;
      this.actionButtons.forEach((button) => { button.classList.toggle('is-loading',loading); button.disabled = loading; });
      this.buybars.forEach((bar) => bar.classList.toggle('is-loading',loading));
      if (loading) this.setUploadProgress(0);
      else { this.setUploadProgress(0); this.updateActionButtons(); }
    }

    setUploadProgress(percentage) {
      const value = this.clamp(Number(percentage) || 0,0,100);
      this.progressFills.forEach((fill) => { fill.style.width = `${value}%`; });
      this.progressTracks.forEach((track) => track.setAttribute('aria-valuenow',String(Math.round(value))));
    }

    emitEvent(action,extra = {}) {
      const eventName = action.startsWith('cgl_') ? action : `cgl_${action}`;
      this.markCustomizerStarted(action);
      const legacyAction = action === 'add_to_cart_success' ? 'added_to_cart' : action;
      const detail = { ...this.analyticsPayload(), ...extra, action:legacyAction, event_name:eventName };
      document.dispatchEvent(new CustomEvent('cgl:photo-customizer',{ detail }));
      this.publishAnalytics(eventName,detail);
    }

    initAnalyticsView() {
      const recordView = () => this.emitEventOnce('customizer_view',{ visibility_method:'viewport' });
      if (!('IntersectionObserver' in window)) return recordView();
      this.analyticsViewObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= .2)) return;
        recordView();
        this.analyticsViewObserver?.disconnect();
      },{ threshold:[.2] });
      this.analyticsViewObserver.observe(this);
    }

    markCustomizerStarted(source) {
      if (source === 'customizer_view' || source === 'add_to_cart_success' || source === 'add_to_cart_error') return;
      this.emitEventOnce('customizer_start',{ start_source:source });
    }

    trackCompletionIfReady() {
      if (!this.isReady()) return;
      this.emitEventOnce('customizer_completed');
      this.persistProgress('complete');
    }

    emitEventOnce(action,extra = {}) {
      const eventName = action.startsWith('cgl_') ? action : `cgl_${action}`;
      if (this.analyticsOnce.has(eventName)) return;
      this.analyticsOnce.add(eventName);
      const detail = { ...this.analyticsPayload(), ...extra, action, event_name:eventName };
      document.dispatchEvent(new CustomEvent('cgl:photo-customizer',{ detail }));
      this.publishAnalytics(eventName,detail);
    }

    analyticsPayload() {
      const acquisition = this.acquisition || {};
      return {
        event_version:this.analyticsVersion,
        cgl_session_id:this.cglSessionId,
        cgl_customization_id:this.cglCustomizationId,
        product_id:String(this.product?.id || this.dataset.productId || ''),
        variant_id:String(this.currentVariant?.id || ''),
        pendant:this.build.selected.Pendant,
        chain:this.build.selected.Chain,
        material:this.build.selected.Material,
        color:this.build.color,
        length:this.build.length,
        price:Number((this.currentPrice() / 100).toFixed(2)),
        price_cents:this.currentPrice(),
        currency:window.Shopify?.currency?.active || 'USD',
        current_step:this.currentStep(),
        photo_uploaded:Boolean(this.build.photoState.renderable),
        pendant_count:1,
        utm_source:acquisition.utm_source || '',
        utm_medium:acquisition.utm_medium || '',
        utm_campaign:acquisition.utm_campaign || '',
        utm_content:acquisition.utm_content || '',
        utm_term:acquisition.utm_term || '',
        referrer_host:acquisition.referrer_host || '',
        meta_click_id_present:Boolean(acquisition.fbclid),
        customizer_preset:this.dataset.customizerPreset || 'all',
        pendant_selection_source:this.fixedPendant ? 'product_preset' : 'customer',
        occurred_at:new Date().toISOString()
      };
    }

    publishAnalytics(eventName,payload) {
      const analyticsPayload = { ...payload };
      delete analyticsPayload.event_name;
      if (this.analyticsDebug) console.info(`[CustomGLD] ${eventName}`,analyticsPayload);
      try {
        if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish(eventName,analyticsPayload);
      } catch (error) { console.debug('CustomGLD Shopify analytics bridge unavailable.',error); }
      try {
        if (typeof window.gtag === 'function') window.gtag('event',eventName,analyticsPayload);
        else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event:eventName, ...analyticsPayload });
      } catch (error) { console.debug('CustomGLD Google analytics bridge unavailable.',error); }
      try {
        if (typeof window.clarity === 'function') window.clarity('event',eventName);
      } catch (error) { console.debug('CustomGLD Clarity analytics bridge unavailable.',error); }
    }

    currentStep() {
      if (!this.pendantComplete()) return 'pendant';
      if (!this.build.photoConfirmed) return 'photo';
      if (!this.build.materialChosen) return 'material';
      return this.isReady() ? 'complete' : 'chain';
    }

    firstMissingStep() {
      if (!this.build.pendantChosen || !this.build.colorChosen) return 'pendant';
      if (!this.build.photoConfirmed || !this.build.photoState.renderable) return 'photo';
      if (!this.build.materialChosen) return 'material';
      if (!this.currentVariant?.available) return 'variant';
      return '';
    }

    storageGet(storage,key) {
      try { return storage?.getItem(key) || ''; }
      catch (error) { return ''; }
    }

    storageSet(storage,key,value) {
      try { storage?.setItem(key,value); }
      catch (error) { /* Storage can be unavailable in strict privacy modes. */ }
    }

    makeAnonymousId(prefix) {
      const random = typeof crypto?.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2,12)}`;
      return `${prefix}_${random}`;
    }

    getOrCreateSessionId() {
      const key = 'cgl_session_id_v1';
      const existing = this.storageGet(window.sessionStorage,key);
      if (existing) return existing;
      const created = this.makeAnonymousId('cgls');
      this.storageSet(window.sessionStorage,key,created);
      return created;
    }

    progressStorageKey() {
      return `cgl_customizer_progress_v${this.persistenceVersion}:${this.product?.id || this.dataset.productId || 'product'}`;
    }

    getStoredProgress() {
      const raw = this.storageGet(window.localStorage,this.progressStorageKey());
      if (!raw) return null;
      try {
        const progress = JSON.parse(raw);
        if (!progress?.expires_at || Date.now() >= progress.expires_at) {
          window.localStorage?.removeItem(this.progressStorageKey());
          return null;
        }
        return progress;
      } catch (error) { return null; }
    }

    getOrCreateCustomizationId() {
      const existing = this.getStoredProgress()?.customization_id;
      return existing || this.makeAnonymousId('cglc');
    }

    getOrCaptureAcquisition() {
      const key = 'cgl_acquisition_v1';
      const existing = this.storageGet(window.sessionStorage,key);
      if (existing) {
        try { return JSON.parse(existing); }
        catch (error) { /* Capture a clean value below. */ }
      }
      const query = new URLSearchParams(window.location.search);
      let referrerHost = '';
      try { referrerHost = document.referrer ? new URL(document.referrer).hostname : ''; }
      catch (error) { referrerHost = ''; }
      const acquisition = {
        utm_source:query.get('utm_source') || '',
        utm_medium:query.get('utm_medium') || '',
        utm_campaign:query.get('utm_campaign') || '',
        utm_content:query.get('utm_content') || '',
        utm_term:query.get('utm_term') || '',
        fbclid:query.get('fbclid') || '',
        gclid:query.get('gclid') || '',
        referrer_host:referrerHost,
        landing_path:window.location.pathname,
        captured_at:new Date().toISOString()
      };
      this.storageSet(window.sessionStorage,key,JSON.stringify(acquisition));
      return acquisition;
    }

    restoreProgress() {
      const progress = this.getStoredProgress();
      if (!progress?.selections) {
        if (this.fixedPendant) {
          this.build.selected.Pendant = this.dataset.defaultPendant || 'Circle';
          this.build.pendantChosen = true;
        }
        return;
      }
      const validOption = (name,value) => [...this.querySelectorAll(`[data-cgl-option="${name}"]`)].some((input) => input.value === value);
      const validColor = (value) => [...this.querySelectorAll('[data-cgl-color]')].some((input) => input.value === value);
      if (this.fixedPendant) {
        this.build.selected.Pendant = this.dataset.defaultPendant || 'Circle';
        this.build.pendantChosen = true;
      } else if (validOption('Pendant',progress.selections.pendant)) {
        this.build.selected.Pendant = progress.selections.pendant;
        this.build.pendantChosen = Boolean(progress.pendant_chosen);
      }
      if (validOption('Material',progress.selections.material)) {
        this.build.selected.Material = progress.selections.material;
        this.build.materialChosen = Boolean(progress.material_chosen);
      }
      if (validColor(progress.selections.color)) {
        this.build.color = progress.selections.color;
        this.build.colorChosen = Boolean(progress.color_chosen);
      }
      /* Rope + 18 inches are intentional clean defaults on every fresh page load. */
    }

    persistProgress(lastStep = this.currentStep()) {
      const progress = {
        version:this.persistenceVersion,
        customization_id:this.cglCustomizationId,
        product_id:String(this.product?.id || ''),
        selections:{
          pendant:this.build.selected.Pendant,
          chain:this.build.selected.Chain,
          material:this.build.selected.Material,
          color:this.build.color,
          length:this.build.length
        },
        pendant_chosen:this.build.pendantChosen,
        color_chosen:this.build.colorChosen,
        material_chosen:this.build.materialChosen,
        photo_was_uploaded:Boolean(this.build.originalFile),
        photo_was_confirmed:Boolean(this.build.photoConfirmed),
        last_step:lastStep,
        updated_at:Date.now(),
        expires_at:Date.now() + this.persistenceDays * 86400000
      };
      this.storageSet(window.localStorage,this.progressStorageKey(),JSON.stringify(progress));
    }

    safeFileType(file) {
      const type = String(file?.type || '').toLowerCase();
      if (type.startsWith('image/')) return type.slice(6,20);
      const extension = String(file?.name || '').split('.').pop()?.toLowerCase();
      return ['heic','heif'].includes(extension) ? extension : 'image';
    }

    safeErrorCode(error) {
      const message = String(error?.message || '').toLowerCase();
      if (message.includes('connection')) return 'network_error';
      if (message.includes('preview')) return 'preview_error';
      if (message.includes('photo')) return 'photo_error';
      return 'cart_error';
    }

    updatePhotoEditDetails() {
      this.querySelectorAll('[data-cgl-photo-edit-detail]').forEach((detail) => {
        const key = detail.dataset.cglPhotoEditDetail;
        const checked = this.photoEditInputs.some((input) => input.dataset.cglPhotoEditReveal === key && input.checked);
        detail.hidden = !checked;
        if (!checked) {
          const field = detail.querySelector('input');
          if (field) field.value = '';
        }
      });
    }

    resetPhotoEdits() {
      this.photoEditInputs?.forEach((input) => { input.checked = false; });
      if (this.photoEditOther) this.photoEditOther.value = '';
      if (this.photoEditsWrap) this.photoEditsWrap.open = false;
      this.updatePhotoEditDetails?.();
    }

    openInfoDialog(kind,trigger) {
      if (!this.infoDialog) return;
      const titles = { pendant:'Pendant size guide', length:'Chain length guide', fine:'Fine Jewelry details' };
      const activePanel = this.infoPanels.find((panel) => panel.dataset.cglInfoPanel === kind);
      if (!activePanel) return;
      this.infoPanels.forEach((panel) => { panel.hidden = panel !== activePanel; });
      if (this.infoTitle) this.infoTitle.textContent = titles[kind] || 'Product details';
      this.infoReturnFocus = trigger || document.activeElement;
      if (typeof this.infoDialog.showModal === 'function') this.infoDialog.showModal();
      else this.infoDialog.setAttribute('open','');
      document.body.classList.add('cgl-pc-info-open');
      this.emitEvent('info_opened',{ info_type:kind });
      window.requestAnimationFrame(() => this.infoTitle?.focus({ preventScroll:true }));
    }

    closeInfoDialog() {
      if (!this.infoDialog?.open) return;
      if (typeof this.infoDialog.close === 'function') this.infoDialog.close();
      else this.infoDialog.removeAttribute('open');
      document.body.classList.remove('cgl-pc-info-open');
      this.infoReturnFocus?.focus?.({ preventScroll:true });
      this.infoReturnFocus = null;
    }

    safeAnalyticsValue(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g,'_').replace(/^_|_$/g,'').slice(0,40);
    }

    setText(selector,text) { this.querySelectorAll(selector).forEach((element) => { element.textContent = text; }); }

    formatMoney(cents) {
      const value = Number(cents || 0);
      const match = this.moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      const placeholder = match ? match[1] : 'amount';
      let amount;
      if (placeholder === 'amount_no_decimals') amount = (value / 100).toLocaleString('en-US',{ maximumFractionDigits:0 });
      else if (placeholder === 'amount_with_comma_separator') amount = (value / 100).toFixed(2).replace('.',',');
      else if (placeholder === 'amount_no_decimals_with_comma_separator') amount = Math.round(value / 100).toLocaleString('de-DE');
      else amount = (value / 100).toLocaleString('en-US',{ minimumFractionDigits:0, maximumFractionDigits:2 });
      return match ? this.moneyFormat.replace(match[0],amount) : `$${amount}`;
    }

    showError(element,message) { if (element) { element.textContent = message; element.hidden = false; } }
    hideError(element) { if (element) { element.textContent = ''; element.hidden = true; } }
    clamp(value,minimum,maximum) { return Math.min(maximum,Math.max(minimum,value)); }
  }

  customElements.define('cgl-photo-customizer',CglPhotoCustomizer);
})();